export const renderPaymentMethods = (
	billingProfiles: any,
	oneTimePaymentType?: any,
	values?: any,
	oneTime?: any
) => {
	console.log("BPS", billingProfiles)
	let paymentMethods: any;
	if (billingProfiles && billingProfiles.length === 0 && !oneTime) {
		paymentMethods = (
			<option value={"No payment methods found"}>
				No payment methods found
			</option>
		);
	} else if (billingProfiles) {
		paymentMethods = billingProfiles.map((profile: any) => (
			<>
				{profile.accountNumber ? (
					<option key={profile.id} value={profile.id}>
						{profile.creditCardType} ends in{" "}
						{profile.accountNumber?.substr(profile.accountNumber.length - 4)}
						{profile.isDefaultProfile ? " (Default)" : null}
					</option>
				) : (
					<option key={profile.id} value={profile.id}>
						{profile.accountTypeFull} ends in{" "}
						{profile.account?.substr(profile.account.length - 4)}
						{profile.isDefaultProfile ? " (Default)" : null}
					</option>
				)}
			</>
		));
	}
	return paymentMethods;
};
